<template>
  <div class="sidebar"
       :style="sidebarStyle"
       :data-color="backgroundColor"
       :data-image="backgroundImage">
    <div class="sidebar-wrapper">
      <div class="logo">
        <a href="#" class="simple-text logo__container">
            <div class="logo-img">
                <img  src="img/cloud.png" alt="">
            </div>
          {{ title }}

        </a>
      </div>

      <slot name="content"></slot>
      <ul class="nav nav-main__links">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="link.name + index"
                        :to="link.path"
                        @click="closeNavbar"
                        :link="link">
            <i :class="link.icon"></i>
            <p>{{link.name}}</p>
          </sidebar-link>
        </slot>
      </ul>
      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
  import SidebarLink from './SidebarLink.vue'

  export default {
    components: {
      SidebarLink
    },
    props: {
      title: {
        type: String,
        default: 'Cloud AM'
      },
      backgroundColor: {
        type: String,
        default: 'blue',
        validator: (value) => {
          let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundImage: {
        type: String,
        default: ''
      },
      activeColor: {
        type: String,
        default: 'primary',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide () {
      return {
        autoClose: this.autoClose
      }
    },
    computed: {
      sidebarStyle () {
        return {
          backgroundImage: `url(${this.backgroundImage})`
        }
      }
    }
  }

</script>
<style>
  .sidebar .sidebar-wrapper {
    display: flex;
    flex-direction: column;
  }
  
  .sidebar .nav-main__links {
    flex: 1;
  }
  
  .sidebar .sidebar-wrapper .logo .logo__container {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
  }
  
  .sidebar .sidebar-wrapper .logo .logo-img img {
    width: 32px;
    margin-right: 10px;
  }
  
  .sidebar .nav li a {
    margin: 8px 15px;
    border-radius: 8px;
    transition: all 0.3s ease;
  }
  
  .sidebar .nav li a:hover,
  .sidebar .nav li a:focus {
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.07), 0 1px 2px -1px rgba(0, 0, 0, 0.05);
    transform: translateY(-1px);
  }
  
  .sidebar .nav li.active > a {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -1px rgba(0, 0, 0, 0.1);
    color: white;
  }
  
  .sidebar[data-color="blue"] .nav li.active > a {
    background: rgba(75, 85, 99, 0.8);
  }
  
  .sidebar[data-color="green"] .nav li.active > a {
    background: linear-gradient(to right, #10B981, #059669);
  }
</style>
